module.exports = __webpack_public_path__ + "img/1w.19e241da.svg";